import { render, staticRenderFns } from "./MyEvaluation.vue?vue&type=template&id=6588fb6a&"
import script from "./MyEvaluation.vue?vue&type=script&lang=js&"
export * from "./MyEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports